import React from "react";
import { PumpBadge, MiniBar } from "./stpHelpers";

const StpSludgePanel = ({ d }) => {
  const { sludge } = d;
  const levelCol = sludge.tankLevel > 80 ? "#ef4444" : sludge.tankLevel > 60 ? "#f59e0b" : "#10b981";

  return (
    <div className="stp-sludge-panel">

      {/* Status cards */}
      <div className="stp-sludge-status">
        <div className="stp-sl-status-card" style={{ borderTopColor: levelCol }}>
          <div className="stp-sls-val" style={{ color: levelCol }}>{sludge.tankLevel}%</div>
          <div className="stp-sls-lbl">Sludge Tank Level</div>
          <div style={{ marginTop: 8 }}><MiniBar value={sludge.tankLevel} max={100} color={levelCol} height={10} /></div>
          <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>
            {sludge.tankLevel > 80 ? "⚠ High — schedule removal soon" : sludge.tankLevel > 60 ? "Monitor closely" : "Normal level"}
          </div>
        </div>

        <div className="stp-sl-status-card" style={{ borderTopColor: "#3b82f6" }}>
          <div className="stp-sls-lbl" style={{ marginBottom: 8 }}>Dewatering Status</div>
          <PumpBadge status={sludge.dewateringStatus} />
          <div style={{ fontSize: 11, color: "#6b7280", marginTop: 8 }}>Last removal: {sludge.lastRemoval}</div>
        </div>

        <div className="stp-sl-status-card" style={{ borderTopColor: sludge.dryingCycleActive ? "#10b981" : "#6b7280" }}>
          <div className="stp-sls-lbl">Sludge Drying Bed</div>
          <div className="stp-sls-val" style={{ color: sludge.dryingCycleActive ? "#10b981" : "#6b7280" }}>
            {sludge.dryingBedLevel}%
          </div>
          <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>
            {sludge.dryingCycleActive ? "Drying cycle active" : "Drying cycle idle"}
          </div>
          <div style={{ marginTop: 8 }}><MiniBar value={sludge.dryingBedLevel} max={100} color={sludge.dryingCycleActive ? "#10b981" : "#94a3b8"} height={8} /></div>
        </div>
      </div>

      {/* Removal log */}
      <div className="stp-chart-card">
        <div className="stp-section-title">Sludge Removal Log</div>
        <table className="stp-table">
          <thead>
            <tr><th>Date</th><th>Volume (m³)</th><th>Destination</th><th>Operator</th><th>Vehicle</th></tr>
          </thead>
          <tbody>
            {sludge.removalLog.map((entry, i) => (
              <tr key={i}>
                <td>{entry.date}</td>
                <td style={{ fontWeight: 600, color: "#667eea" }}>{entry.volume}</td>
                <td>
                  <span className="stp-badge" style={{ background: entry.destination.includes("Compost") ? "#d1fae5" : "#fef3c7", color: entry.destination.includes("Compost") ? "#10b981" : "#f59e0b", fontSize: 11 }}>
                    {entry.destination}
                  </span>
                </td>
                <td>{entry.operator}</td>
                <td style={{ fontSize: 12, color: "#6b7280" }}>{entry.truckId}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Controls */}
      <div className="stp-sludge-controls">
        <div className="stp-section-title">Sludge Operations</div>
        <div className="stp-sc-row">
          <button className="stp-ctrl-btn stp-ctrl-green">▶ Start Dewatering</button>
          <button className="stp-ctrl-btn stp-ctrl-red">⏹ Stop Dewatering</button>
          <button className="stp-ctrl-btn stp-ctrl-blue">+ Log Manual Removal</button>
          <button className="stp-ctrl-btn stp-ctrl-purple">⬇ Export Log</button>
        </div>
      </div>

      <div className="stp-ai-strip">
        🤖 AI: Sludge tank at 45% — normal. Based on inflow trend, next removal due in ~3 days. Composting facility preferred for sustainability score improvement.
      </div>
    </div>
  );
};

export default StpSludgePanel;
